import React from 'react'

const Dashboard = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66667 12V5.33333H12V12H6.66667ZM0 6.66667V0H5.33333V6.66667H0ZM4 5.33333V1.33333H1.33333V5.33333H4ZM0 12V8H5.33333V12H0ZM1.33333 10.6667H4V9.33333H1.33333V10.6667ZM8 10.6667H10.6667V6.66667H8V10.6667ZM6.66667 0H12V4H6.66667V0ZM8 1.33333V2.66667H10.6667V1.33333H8Z" fill="#2D3748" />
        </svg>

    )
}

export default Dashboard